import { render, staticRenderFns } from "./BOM.vue?vue&type=template&id=248122fc&scoped=true&"
import script from "./BOM.vue?vue&type=script&lang=js&"
export * from "./BOM.vue?vue&type=script&lang=js&"
import style0 from "./BOM.vue?vue&type=style&index=0&id=248122fc&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "248122fc",
  null
  
)

export default component.exports